import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Sidebar from "../../component/sidebar";
import Header from "../../component/header";
import Controls from "../forms/controls/Controls";
import { useForm, Form } from "../forms/useForm";
import { useGetMissionsByIdQuery } from "../../../../services/missionSlice";
import BlobToFile from "../forms/utils/blobToFile";
import { useUpdateMissionMutation } from "../../../../services/missionSlice";
import urlToFile from "../forms/utils/urlToFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faBell,
  faSignInAlt,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const MissionEditPage = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <EditMissionPages />
      </Grid>
    </Grid>
  );
};

const EditMissionPages = () => {
  const { id } = useParams();
  
  const Missions = useGetMissionsByIdQuery(id);
  const [File, setFile] = useState([]);
  const [updateMission, setUpdateMission] = useState([]);
  const [initialFValues, setInitialFValues] = useState({
    mission_name: "",
    is_active: false,
  });

  const [SuccessMessege, setSuccesMessege] = useState(null);
  const [ErrorMessege, setErrorMessege] = useState(null);
  const history = useNavigate();

  useEffect(() => {
    if (Missions.data) {
      urlToFile(Missions.data.image, setFile);
      setInitialFValues({
        mission_name: Missions.data.mission_name,
        is_active: Missions.data.is_active
      });
    }
  }, [Missions.data]);

  const { values, handleImageUpload, handleInputChange } = useForm(
    initialFValues,
    true,
    false,
    true
  );

  const [editMission] = useUpdateMissionMutation();


  

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    if(values.mission_name)
      formData.append("mission_name", values.mission_name);
    if(values.is_active)
      formData.append("is_active", values.is_active)
    formData.append("id", id);
    editMission(formData)
      .then((res) => {
        setSuccesMessege("Successfully Updated Missions Data.");
        setTimeout(() => {
          history("/dashboard/mission");
        }, [3000]);
      })
      .catch((err) => {
        setErrorMessege("Some Error Occur. Please Try Again Later.");
        setTimeout(() => {
          setErrorMessege(null);
        }, [3000]);
      });
  };

  return (
    <Box className="table-design-background">
      <Typography className="dashboard-home-page-text">
        Update Mission List
      </Typography>
      <Box style={{ padding: "1.5rem" }}>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={6}>
              <Controls.Input
                name="mission_name"
                label="Mission Name"
                value={values.mission_name}
                onChange={handleInputChange}
              />

              <Controls.RadioGroup
                name="is_active"
                label="Is Active"
                value={values.is_active.toString()}
                onChange={handleInputChange}
                items={[
                  { id: "false", title: "False" },
                  { id: "true", title: "True" },
                ]}
              />

            </Grid>
          </Grid>
          <Grid container>
          <Grid style={{ marginTop: "12px" }}>
              <Controls.Button
                type="submit"
                text="Submit"
                backgroundColor="#1b284b"
                onClick={handleSubmit}
              />
            </Grid>
            </Grid>

        </Form>
        {SuccessMessege === null ? null : (
          <Box className="successmessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon icon={faCheckCircle} className="messegeicon" />
              {SuccessMessege}
            </Typography>
          </Box>
        )}
        {ErrorMessege === null ? null : (
          <Box className="errormessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="messegeicon"
              />
              {ErrorMessege}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MissionEditPage;
